import { createContext, ReactNode, useContext, useState } from "react";

export const DRAWER_WIDTH = 240;
export const APP_BAR_HEIGHT = 64;

interface LayoutContextType {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  drawerWidth: number;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  return (
    <LayoutContext.Provider
      value={{
        isDrawerOpen,
        setIsDrawerOpen,
        drawerWidth: DRAWER_WIDTH
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = (): LayoutContextType => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error("useLayout must be used within a LayoutProvider");
  }
  return context;
};
